import axios, { AxiosResponse } from 'axios';

export const uploadFile = async (file: File, folder: string, key?: string) => {
  let filename = file.name;
  if (key) {
    const keyParts = key.split('/');
    filename = keyParts[keyParts.length - 1];
  }
  const { data: uploadData }: AxiosResponse<{ secureUrl: string; uploadUrl: string; key: string }> = await axios.get(
    `/media/upload`,
    { params: { folder, filename } }
  );
  await axios.put(uploadData.uploadUrl, file, { withCredentials: false, headers: [] });
  return {
    url: uploadData.secureUrl,
    key: uploadData.key,
  };
};
